<template>
  <div>
    <VMessage
      type="warning"
      :fullwidth="true"
      v-if="permissionCompany !== true">
      <template v-slot:icon>
        <ExclamationTriangleIcon />
      </template>
      <template v-slot:text>
        {{ $t('companySettings.company.permissionWarning') }}
      </template>
    </VMessage>
    <div ref="container" v-if="permissionCompany === true">
      <VButton
          type="cta-1"
          class="apikey-create-button"
          data-ec="developer_api_keys"
          data-et="add_api_key_button"
          :action="openCreateApiKeyModal">
        <PlusIcon />
        <span>{{ $t('companySettings.developer.apikeys.add') }}</span>
      </VButton>

      <h3>{{ $t('companySettings.developer.apikeys.keys') }}</h3>

      <VMessage
        class="apikey-message-box"
        type="info"
        :fullwidth="true">
        <template v-slot:icon>
          <BookIcon />
        </template>
        <template v-slot:text>API documentation available at: <a class="apikey-message-box-link" href="https://developer.signable.co.uk/">developer.signable.co.uk</a></template>
      </VMessage>

      <VTable
        :loading="!$store.getters['apiKeys/hasLoaded']"
        :thead="[
            { value: $t('companySettings.developer.apikeys.name'), width: 55 },
            { value: $t('companySettings.developer.apikeys.type'), width: 15 },
            { value: $t('companySettings.developer.apikeys.created'), width: 30 },
          ]"
        :tbody="$store.getters['apiKeys/pagedResults']"
        :columns="['name', 'type', 'created_at' ]"
        :stringFormatter="{ type: formatKeyType }"
        :dateFormatter="{ created_at: 'short' }"
        :actions="true"
        :noResultsMessage="$t('companySettings.developer.noApiKeys')"
        data-hj-suppress>
        <template slot-scope="apikey">
          <VButton
            type="outline-1"
            size="small"
            data-ec="developer_api_keys"
            data-et="edit_api_key_button"
            :tooltip="$t('companySettings.developer.apikeys.edit')"
            @click="openApiKeyEditModal(apikey)"
            :iconOnly="true"
            :rounded="true">
            <PencilIcon />
          </VButton>
          <VButton
            type="outline-1"
            size="small"
            data-ec="developer_api_keys"
            data-et="delete_api_key_button"
            :tooltip="$t('companySettings.developer.apikeys.delete')"
            @click="openApiKeyDeleteModal(apikey)"
            :iconOnly="true"
            :rounded="true">
            <TrashIcon />
          </VButton>
        </template>
      </VTable>

      <VPaginate
        v-if="$store.state.apiKeys.totalCount > $store.state.apiKeys.pagingLimit"
        storeAction="apiKeys/PAGINATE"
        :previous="$t('functional.previous')"
        :next="$t('functional.next')"
        :current="$store.getters['apiKeys/currentPage'] + 1"
        :last="$store.getters['apiKeys/totalPages']"
        :useUrl="false" />

      <VDynamicLoader
        viewURL="modals/apikey/AddEdit"
        :data="{item: selectedItem}"
      />

      <VDynamicLoader
        viewURL="modals/apikey/Delete"
        :data="{item: selectedItem}"
      />
    </div>
  </div>
</template>

<script>
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VPaginate from '@/components/deprecated/molecules/Paginate.vue';
import VTable from '@/components/deprecated/molecules/Table.vue';
import VDynamicLoader from '@/components/DynamicLoader.vue';
import { mapGetters } from 'vuex';
import { BookIcon, ExclamationTriangleIcon, PencilIcon, PlusIcon, TrashIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ApiKeys',
  components: {
    VMessage,
    VButton,
    VPaginate,
    VTable,
    VDynamicLoader,
    PencilIcon,
    PlusIcon,
    TrashIcon,
    ExclamationTriangleIcon,
    BookIcon,
  },
  data() {
    return {
      selectedItem: {},
    };
  },
  mounted() {
    this.$store.dispatch('apiKeys/PAGINATE', { page: 1 });
  },
  computed: {
    ...mapGetters({
      userHasRole: 'roles/userHasRole',
    }),
    permissionCompany() {
      return this.userHasRole('super-admin');
    },
  },
  methods: {
    openCreateApiKeyModal() {
      this.selectedItem = {
        name: '',
        type: 'live',
      };
      this.$bus.$emit('toggleModal', { name: 'addedit-apikey-modal', active: true });
    },
    openApiKeyEditModal(item) {
      this.selectedItem = item;
      this.$bus.$emit('toggleModal', { name: 'addedit-apikey-modal', active: true });
    },
    openApiKeyDeleteModal(item) {
      this.selectedItem = item;
      this.$bus.$emit('toggleModal', { name: 'delete-apikey-modal', active: true });
    },
    formatKeyType(field) {
      return field.type ? this.$t(`companySettings.developer.apikeys.types.${field.type}`) : '';
    },
  },
};
</script>

<style scoped>
.apikey-message-box-link {
  color: #fff;
}
.apikey-message-box {
  margin: 0.5em 0;
}
.apikey-create-button {
  float: right;
}
</style>
